import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

function ProtectedAdminRoute({ children }) {
  const { isAdminLoggedIn, checked } = useAdminAuth();
  const location = useLocation();

  if (!checked) {
    return (
      <div className="admin-login-page" style={{ alignItems: 'center', justifyContent: 'center' }}>
        <p>Loading…</p>
      </div>
    );
  }

  if (!isAdminLoggedIn) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedAdminRoute;
